import React, { useContext, useEffect } from "react";
import config from "config";
import { MsalContext } from "Auth/msal-context";
import { messengerRequest } from "Auth/auth-config";
import { DevicesConfig, RefreshSignalR } from "../../../src/Dashboard/actions/apiActions";
import { useDispatch } from "react-redux";
import { useSocketConnectionDevicesMessageTypeEvent } from "../../../src/Dashboard/helpers/useSocketConnection";
import Socket from "Socket/socket.js";
import { closeSocket } from "../../../src/Dashboard/ducks/socketDuck";
import { fetchDevicesConfigs, fetchDevicesConfigsRaw } from "../../../src/Dashboard/ducks/devicesConfigsDuck";

const FetchSensorConfigs = ({ site }) => {
  const dispatch = useDispatch();

  // GET SENSOR CONFIG, OTHERWISE WE DON'T HAVE INFORMATION OF THE SITE'S SYSTEMS DEVICES
  useEffect(() => {
    site.devices.forEach((system) => {
      // Initialize Redux tiers for this device so fulfilled actions are stored
      const initPayload = { systemId: system.deviceId, solutionType: system.solutionType };
      dispatch({ type: "config/initializeDeviceConfig", payload: initPayload });
      dispatch({ type: "realtime/initializeDeviceRealtime", payload: initPayload });

      const url = config.CONFIGURATION_URL;
      const systemId = system.deviceId;
      const payload = {
        customerId: site.customerId,
        deviceId: system.deviceId,
        file: system.config,
        isSensor: system.solutionType === "lora" ? true : false,
      };
      dispatch(fetchDevicesConfigs({ systemId, url, ...payload }));
    });
  }, [site]);


  return null;
};

export default FetchSensorConfigs;
